import React, { FunctionComponent } from 'react';
import { Spring } from 'react-spring/renderprops';
import TrackVisibility from 'react-on-screen';

interface MockupProps {
  fileName: string;
  alt: string;
}

export const Mockup: FunctionComponent<MockupProps> = ({ fileName, alt }) => {
  const mockupMaxWidth = 160;
  const ratio = 460 / 160;
  const margin = 2 * 2 * 8;
  const mockupWidth = Math.min(
    mockupMaxWidth,
    (window.innerWidth - margin) / 2
  );
  const mockupHeight = mockupWidth * ratio;
  return (
    <TrackVisibility partialVisibility once>
      {({ isVisible }) => (
        <Spring
          delay={300}
          to={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(80px)',
          }}
        >
          {(props) => (
            <picture>
              <source
                type="image/webp"
                data-src={'assets/jak-działa-aplikacja/' + fileName + '.webp'}
              />
              <img
                style={props}
                data-src={'assets/jak-działa-aplikacja/' + fileName + '.png'}
                alt={alt}
                width={mockupWidth}
                height={mockupHeight}
                className="lazyload"
              />
            </picture>
          )}
        </Spring>
      )}
    </TrackVisibility>
  );
};

export default Mockup;
